import { SceneId } from ".";

export type ActionExpression = ActionExpressionValue | ActionCondition;

export type ActionCondition =
    | {
          not: ActionExpression;
      }
    | {
          and: ActionExpression[];
      }
    | {
          or: ActionExpression[];
      }
    | {
          eq: [ActionExpression, ActionExpression];
      }
    | {
          gt: [ActionExpression, ActionExpression];
      }
    | {
          lt: [ActionExpression, ActionExpression];
      }
    | {
          gte: [ActionExpression, ActionExpression];
      }
    | {
          lte: [ActionExpression, ActionExpression];
      }
    | {
          hasVisitedScene: SceneId;
      };

export type ActionExpressionValue = boolean | string | number | null;

export const ACTION_EXPRESSION_CONDITIONALS = [
    "and",
    "or",
    "eq",
    "gt",
    "lt",
    "gte",
    "lte",
] as const;
